import { pipe } from 'fp-ts/lib/function';
import * as E from 'fp-ts/Either';
import { G } from 'enums';
import { FormField } from 'components';
import { useFullTextValidation } from 'utils';
import { useIntl } from 'react-intl';

interface Props {
  onReset?: () => void;
  onChange: (p: { kind: 'eurotax' | 'plate' | 'constructor_code' | string; value: string }) => void;
  readonly value: string;
}
export const FullTextSearchInput: (p: Props) => JSX.Element = ({ onChange, value }) => {
  const intl = useIntl();
  const { validate } = useFullTextValidation();
  const handleChange = (e: string): E.Either<string, void> => pipe(e.toUpperCase(), validate, E.map(onChange));
  return (
    <FormField
      type="Search"
      name={G.search}
      value={value}
      label={intl.formatMessage({ id: 'search-field.code' })}
      placeholder={intl.formatMessage({ id: 'search-field.code.placeholder' })}
      onChange={handleChange}
    />
  );
};
